import http from 'hub-http/clients/apiClient';
export function getTourStatus(tourKey) {
  return http.get(`/onboarding/tours/v1/status/${tourKey}`);
}
export function updateTourStatus(tourKey, status) {
  return http.post(`/onboarding/tours/v1/status`, {
    data: {
      tourKey,
      status
    }
  });
}